/* Vidaderma Campaign — lightweight carousel (no dependencies).
   Native scroll-snap does the sliding; this only wires arrows + progress. */
(function () {
  if (customElements.get('cmp-carousel')) return;

  class CmpCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-cmp-track]');
      this.prev = this.querySelector('[data-cmp-prev]');
      this.next = this.querySelector('[data-cmp-next]');
      this.nav = this.querySelector('[data-cmp-nav]');
      this.bar = this.querySelector('[data-cmp-progress] span');
      if (!this.track) return;

      this.update = this.update.bind(this);
      this.prev && this.prev.addEventListener('click', () => this.go(-1));
      this.next && this.next.addEventListener('click', () => this.go(1));
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.ro = new ResizeObserver(this.update);
      this.ro.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      this.ro && this.ro.disconnect();
    }

    step() {
      const item = this.track.firstElementChild;
      if (!item) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    go(dir) {
      this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
    }

    update() {
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth;
      const scrollable = max > 2 && getComputedStyle(t).overflowX !== 'visible';
      if (this.nav) this.nav.hidden = !scrollable;
      if (!scrollable) return;
      if (this.prev) this.prev.disabled = t.scrollLeft <= 2;
      if (this.next) this.next.disabled = t.scrollLeft >= max - 2;
      if (this.bar) {
        const visible = t.clientWidth / t.scrollWidth;
        this.bar.style.width = (visible * 100) + '%';
        this.bar.style.left = ((t.scrollLeft / t.scrollWidth) * 100) + '%';
      }
    }
  }

  customElements.define('cmp-carousel', CmpCarousel);
})();
